import React from 'react';
import { withStyles, Typography } from '@material-ui/core';
import { capitalize } from 'lodash';

import { extractDisclaimerProperties } from '../../../lib/helpers';
import styles from './styles';
import { isTablet } from '../../../lib/getDeviceSize';

export interface Props {
  classes: any;
  listing: any;
}

export const Disclaimer = (props: Props) => {
  if (!props.listing || !props.listing.mlsSourceShortName) {
    return null;
  }

  const disclaimers: any[] = extractDisclaimerProperties([props.listing]);
  return (
    <div className={props.classes.marginContainer}>
      <div style={{ marginTop: 30 }}>
        {disclaimers.map(({ slug, disclaimerText }: any) => (
          <div key={slug.split('.')[0]} className={props.classes.disclaimer}>
            <img
              key={slug.split('.')[0]}
              alt={`MLS Logo ${capitalize(slug.split('.')[0])}`}
              src={`/static/img/mls_sources/${slug}`}
              height="35"
              className={props.classes.mlsLogo}
            />
            <Typography className={props.classes.disclaimerText}>
              {disclaimerText}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withStyles(styles)(Disclaimer);
